export default __webpack_public_path__ + "static/media/le_lion9.ea4fa923.jpg";